// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_cg-j";
export var fulfillmentFormRail = "_cg-i";
export var headerTitleRow = "_cg-l";
export var orderDetailsWrapper = "_cg-g";
export var orderLinkTrigger = "_cg-2";
export var paymentInformationGrid = "_cg-q";
export var paymentSummaryColumn = "_cg-r";
export var phoneShipmentPickerButton = "_cg-e";
export var phoneShipmentPickerButtonContent = "_cg-f";
export var phoneShipmentPickerButtonWrapper = "_cg-d";
export var phoneShipmentPickerTrigger = "_cg-c";
export var shipmentContainer = "_cg-k";
export var shipmentDetailsMainPane = "_cg-h";
export var shipmentNavigationCard = "_cg-a";
export var shipmentNavigationEdgeTrigger = "_cg-6";
export var shipmentNavigationRail = "_cg-3";
export var shipmentNavigationRailEnter = "_cg-5";
export var shipmentNavigationRailHeader = "_cg-9";
export var shipmentNavigationRailOverlay = "_cg-4";
export var shipmentNavigationScrim = "_cg-7";
export var shipmentSummaryFact = "_cg-n";
export var shipmentSummaryGrid = "_cg-m";
export var shipmentSummaryMetadataRow = "_cg-o";
export var shipmentSummaryTags = "_cg-p";
export var shipmentWorkspace = "_cg-0";
export var shipmentWorkspaceBodyTablet = "_cg-8";
export var shipmentWorkspaceContent = "_cg-b";
export var shipmentWorkspaceHeader = "_cg-1";